import { render, staticRenderFns } from "./FinalizeOauth.vue?vue&type=template&id=0fec7994"
import script from "./FinalizeOauth.vue?vue&type=script&lang=js"
export * from "./FinalizeOauth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports